console.log("\n%c Mercury 2.0.0", "color:#fff;font-size:12px; padding:0.45rem 0.75rem; margin: 0rem auto 1rem auto; font-family: Helvetica, sans-serif; border: 2px solid #0dd8d8; border-radius: 4px;font-weight: 100;background-size: cover;background-repeat: no-repeat;border: double 1px transparent;background-image: linear-gradient(#282828, #282828), radial-gradient(circle at top left, #2563EB, #82a0e2);background-origin: border-box;background-clip: padding-box, border-box;")


/*------------------------------------------------------------------ 
Import styles
------------------------------------------------------------------*/

import '../styles/main.scss';

/*------------------------------------------------------------------ 
Import scripts
------------------------------------------------------------------*/

import { $, $$ } from '@/utilities/helpers';
// import '@/animations/motion';
import { initSlideBackgroundAnimations } from '@/animations/motion';
import '@/components/banner-video';
import { Slider } from '@/components/slider';
import { Accordion } from '@/components/accordion';
import { Feature } from '@/elements/features';
import { FeatureFilter } from '@/elements/feature-filters';
import { Video } from '@/components/video';
import { MobileMenu } from '@/components/mobile-menu';
import { Menu } from '@/components/menu';
import { Investment } from '@/components/investment';


$$('.embla').forEach(element => new Slider(element));
$$('.js-accordion-element').forEach(element => new Accordion(element));
$$('.js-feature').forEach(element => new Feature(element));
$$('.js-feature').forEach(element => new FeatureFilter(element));
$$('.js-video-element').forEach(element => new Video(element));
$$('.js-mobile-menu').forEach(element => new MobileMenu(element));
$$('.js-menu').forEach(element => new Menu(element));
$$('.js-investment').forEach(element => new Investment(element));

/*------------------------------------------------------------------
Start the app
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {

    const moreItem = document.querySelector('.navigation__item--more');
    const navigation = document.querySelector('.navigation');

    let timeout;

    moreItem.addEventListener('mouseenter', () => {
        clearTimeout(timeout); // Clear any existing timeout
        navigation.classList.add('active');
    });

    navigation.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
            navigation.classList.remove('active');
        }, 100);
    });

    navigation.addEventListener('mouseenter', () => {
        clearTimeout(timeout); // Prevent timeout removal when hovering back inside
    });

    /*------------------------------------------------------------------
    Intersection observers for animation styles
    ------------------------------------------------------------------*/

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('inview');
            }
        });
    }, {
        root: null, // Use the viewport as the root
        rootMargin: '-15% 0px' // Trigger when the element is in the middle of the page
    });

    // Add the observer to all elements with the class `js-inview`
    setTimeout(() => $$('.js-inview').forEach(element => observer.observe(element)), 10);


    /*------------------------------------------------------------------
    Global animations
    ------------------------------------------------------------------*/

    initSlideBackgroundAnimations();


    /*------------------------------------------------------------------
    Post Load classname removal:
    This removes the class `js-postload` from elements after the page 
    has loaded, to prevent any unwanted animations.
    ------------------------------------------------------------------*/

    $$('.js-postload').forEach(element => {
        element.classList.remove('js-postload');
    });


    /*------------------------------------------------------------------
    Sticky header:
    It hides/shows the header when scrolling up and down
    ------------------------------------------------------------------*/

    // Initialize the previous scroll position to 0
    let previousScrollPosition = 0;

    // Define the scroll delta to determine significant scroll changes
    const scrollDelta = 5;

    // Select the header element
    const header = document.querySelector('.header');

    // Calculate the header height, defaulting to 0 if the header is not found
    const headerHeight = header ? header.clientHeight / 3 : 0;

    /**
     * Function to handle the sticky header behavior based on scroll position.
     */
    const stickyHeader = () => {
        // If no header is found, exit the function
        if (!header) return;

        // Get the current scroll position
        let currentScroll = window.scrollY;

        // If the scroll change is less than the defined delta, exit the function
        if (Math.abs(previousScrollPosition - currentScroll) <= scrollDelta) return;

        // If at the top of the page, remove any navigation classes
        if (currentScroll === 0) {
            header.classList.remove('nav-down', 'nav-up');
        }
        // If scrolling down and past the header height, hide the header
        else if (currentScroll > previousScrollPosition && currentScroll > headerHeight) {
            header.classList.remove('nav-down');
            header.classList.add('nav-up');
        }
        // If scrolling up and not at the bottom of the page, show the header
        else {
            if (currentScroll + window.innerHeight < document.body.clientHeight) {
                header.classList.add('nav-down');
                header.classList.remove('nav-up');
            }
        }

        // Update the previous scroll position
        previousScrollPosition = currentScroll;

    };

    // Use requestAnimationFrame for smoother scroll event handling
    let isScrolling = false;

    // Add a scroll event listener to the window
    window.addEventListener('scroll', () => {
        // If not already scrolling, use requestAnimationFrame to call stickyHeader
        if (!isScrolling) {

            window.requestAnimationFrame(() => {
                stickyHeader();
                isScrolling = false;
            });

            isScrolling = true;
        }
    });


    /*------------------------------------------------------------------
    Import element scripts
    ------------------------------------------------------------------*/

    if ($('.js-intro-element')) {
        import('@/elements/intro.js')
            .then(module => $$('.js-intro-element').forEach(element => new module.IntroElement(element)))
            .catch(error => console.error("Intro component failed to load", error));
    }


    if ($('.js-case-studies-element')) {
        import('@/elements/case-studies.js')
            .then(module => $$('.js-case-studies-element').forEach(element => new module.CaseStudiesElement(element)))
            .catch(error => console.error("Case study component failed to load", error));
    }

    if ($('.js-next-steps-element')) {
        import('@/elements/next-steps.js')
            .then(module => $$('.js-next-steps-element').forEach(element => new module.NextStepsElement(element)))
            .catch(error => console.error("next-steps component failed to load", error));
    }

    if ($('.js-partners-element')) {
        import('@/elements/partners.js')
            .then(module => $$('.js-partners-element').forEach(element => new module.PartnersElement(element)))
            .catch(error => console.error("Partner component failed to load", error));
    }


    if ($('.js-pow-element')) {
        import('@/elements/pow.js')
            .then(module => $$('.js-pow-element').forEach(element => new module.PowElement(element)))
            .catch(error => console.error("Pow component failed to load", error));
    }

    if ($('.js-start-element')) {
        import('@/elements/start.js')
            .then(module => $$('.js-start-element').forEach(element => new module.StartElement(element)))
            .catch(error => console.error("Start component failed to load", error));
    }

    if ($('.js-team-element')) {
        console.log("Loading team element");
        import('@/elements/team.js')
            .then(module => $$('.js-team-element').forEach(element => new module.TeamElement(element)))
            .catch(error => console.error("Team component failed to load", error));
    }





    // /*------------------------------------------------------------------
    // Theme toggle button
    // ------------------------------------------------------------------*/
    // const toggleButton = document.querySelector('.js-theme-toggle');

    // toggleButton.addEventListener('click', () => {
    //     const root = document.documentElement;

    //     // Check current theme
    //     if (root.classList.contains('theme--dark')) {
    //         // Switch to light
    //         root.classList.remove('theme--dark');
    //         root.classList.add('theme--light');
    //         localStorage.setItem('theme', 'light');
    //     } else {
    //         // Switch to dark
    //         root.classList.remove('theme--light');
    //         localStorage.removeItem('theme');
    //         root.classList.add('theme--dark');
    //         localStorage.setItem('theme', 'dark');
    //     }
    // });

    // // Apply saved preference on load
    // const savedTheme = localStorage.getItem('theme');
    // if (savedTheme === 'dark') {
    //     document.documentElement.classList.add('theme--dark');
    // } else if (savedTheme === 'light') {
    //     document.documentElement.classList.add('theme--light');
    // }
});